const parts = ['container', 'icons', 'mask', 'track', 'tooltip'];

const baseStyleContainer = {
  display: 'inline-flex',
  width: 'fit-content',
  borderRadius: '4px',
  flexDirection: 'row',
  padding: 0,
  position: 'relative',
  color: 'rgba(0,0,0,0.1)', // black 10%
  // outline: 'none',
  boxShadow: 'none',
  _focus: {
    boxShadow: 'none',
    outline: 'none',
  },
  _focusVisible: {
    boxShadow: 'focusVisible',
    outline: 'none',
  },
};

const baseStyleIcons = {
  margin: 0,
  padding: 0,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  outline: 'none',
};

const baseStyleMask = {
  position: 'absolute',
  left: 0,
  top: 0,
  bottom: 0,
  right: '50%',
  overflow: 'hidden',
  display: 'inline-flex',
  alignItems: 'center',
  flexWrap: 'nowrap',
  pointerEvents: 'none',
  color: '#F2A705', // gold
  outline: 'none',
  // backgroundColor: 'rgba(255,0,0,0.5)',
};

const baseStyleTrack = {
  position: 'absolute',
  left: 0,
  top: 0,
  bottom: 0,
  right: 0,
  outline: 'none',
  pointerEvents: 'all',
  // cursor: 'pointer' // assigned by component depending on readonly || disabled
  touchAction: 'none', // prevent drag-to-scroll on mobile
};

const baseStyleTiposition = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  right: '50%',
  width: '1px',
  outline: 'none',
};

const sizes = {
  sm: {
    container: {
      fontSize: '1rem',
      padding: '2px 2px 3px 2px',
    },
    mask: {
      padding: '2px 2px 3px 2px',
    },
    icons: {
      marginRight: '0',
      width: '1.25rem',
      minWidth: '1.25rem',
    },
  },
  md: {
    container: {
      fontSize: '1.25rem',
      padding: '3px 1px 4px 2px',
    },
    mask: {
      padding: '3px 1px 4px 2px',
    },
    icons: {
      marginRight: '0',
      width: '1.75rem',
      minWidth: '1.75rem',
    },
  },
  lg: {
    container: {
      fontSize: '1.5rem',
      padding: '4px 3px 6px 3px',
    },
    mask: {
      padding: '4px 3px 6px 3px',
    },
    icons: {
      marginRight: '0',
      width: '2.125rem',
      minWidth: '2.125rem',
    },
  },
};

const baseStyle = {
  container: baseStyleContainer,
  icons: baseStyleIcons,
  mask: baseStyleMask,
  track: baseStyleTrack,
  tooltip: baseStyleTiposition,
};

const defaultProps = {
  size: 'md',
};

export const Rating = {
  parts,
  baseStyle,
  defaultProps,
  sizes,
};
